import React, { useState, useContext } from "react";
import { useEffect } from "react";
import { Text } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/modals/ModalSelectStoreAndSection";
import FormProduct from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/products/FormProduct";
import ListOfProductsToSetParams from "./ListProductsToSetParams";
import { GlobalContext } from "../../../../../../contexts/GlobalContext";
import { getCategoryAttributes, getFalabellaBrands } from "../../../../../../hooks/api/falabella";
import Select from 'react-select';

export default function SetParamProdToPost({
  paramsToSend,
  setParamsToSend,
  category,
  publishGroup,
  setPublishGroup,
  setRequiredAttributes
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const globalContext = useContext(GlobalContext);
  const [categoryAttributes, setCategoryAttributes] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [notFoundFields, setNotFoundFields] = useState([]);
  const [talla, setTalla] = useState([]);

  // Establecer "Agrupadas" como valor por defecto si no hay valor inicial
  useEffect(() => {
    if (setPublishGroup && !publishGroup) {
      setPublishGroup("true");
    }
  }, [setPublishGroup, publishGroup]);



  useEffect(() => {
    if(paramsToSend.length === 0) globalContext.setModalPostProduct(false)
  }, [paramsToSend]);

  const sendToFormData = async (v, currentPosition) => {
    setCurrentIndex(currentPosition);
  };

  const titleFunc = (v) => {
    console.log(paramsToSend)
    if(paramsToSend.length > 0){
      let copyArray = [...paramsToSend];
      copyArray[currentIndex].Title = v;
      setParamsToSend(copyArray);
    }
    // Limpiar errores si hay
    if (validationErrors.length > 0) {
      setValidationErrors([]);
    }
  };

  const loadBrands = async () => {
    try {
      setLoadingBrands(true);
      const response = await getFalabellaBrands(globalContext.currentEnterpriseId);
      if (response?.data?.data) {
        const brandsList = response.data.data;
        setBrands(brandsList);
      }
    } catch (error) {
      console.error('Error al cargar las marcas:', error);
    } finally {
      setLoadingBrands(false);
    }
  };

  useEffect(() => {
    if (globalContext.currentEnterpriseId) {
      loadBrands();
    }
  }, [globalContext.currentEnterpriseId]);

  const brandFunc = (brandInfo) => {
    let copyArray = [...paramsToSend];
    const [brandId, brandName] = brandInfo.split('|');
    
    // Crear objeto con la información de la marca
    const brandData = {
      brandId: brandId,
      name: brandName
    };

    // Guardar el objeto completo en el producto
    copyArray[currentIndex].Brand = brandData;
    
    console.log('Brand selected:', brandData); // Para debug
    console.log('Updated product:', copyArray[currentIndex]); // Para debug
    
    setParamsToSend(copyArray);
  };

  const packagedHeight = (v) => {
    let copyArray = [...paramsToSend];
    copyArray[currentIndex].PackagedHeight = v;
    setParamsToSend(copyArray);
    // Limpiar errores si hay
    if (validationErrors.length > 0) {
      setValidationErrors([]);
    }
  };
  const packagedLength = (v) => {
    let copyArray = [...paramsToSend];
    copyArray[currentIndex].PackagedLength = v;
    setParamsToSend(copyArray);
    // Limpiar errores si hay
    if (validationErrors.length > 0) {
      setValidationErrors([]);
    }
  };
  const packagedWidth = (v) => {
    let copyArray = [...paramsToSend];
    copyArray[currentIndex].PackagedWidth = v;
    setParamsToSend(copyArray);
    console.log('currentIndex')
    console.log(copyArray[currentIndex].PackagedWidth)
    console.log(currentIndex)
    console.log('currentIndex')
    // Limpiar errores si hay
    if (validationErrors.length > 0) {
      setValidationErrors([]);
    }
  };
  const packagedWeightKg = (v) => {
    let copyArray = [...paramsToSend];
    copyArray[currentIndex].PackagedWeightKg = v;
    setParamsToSend(copyArray);
    // Limpiar errores si hay
    if (validationErrors.length > 0) {
      setValidationErrors([]);
    }
  };


  const bodyFunc = (v) => {
    let copyArray = [...paramsToSend];
    copyArray[currentIndex].Description = v;
    setParamsToSend(copyArray);
  };

  console.log("validamos el index", currentIndex, paramsToSend);

  // Llamar a la función cuando se necesite obtener los atributos de la categoría
  useEffect(() => {
    if (category?.id && globalContext.currentEnterpriseId) {
      getCategoryAttributes(globalContext.currentEnterpriseId, category.id)
        .then(data => {
          if (data) {
            console.log('Category attributes:', data.data.data);
            setCategoryAttributes(data.data.data);

            // --- Comparación para mostrar campos de fieldsToSkip que no existen en los atributos de la categoría ---
            const fieldsToSkip = [
              'price_falabella',
              'sale_price_falabella', 
              'sale_start_date_falabella',
              'sale_end_date_falabella',
              'TaxClass',
              'quantity_falabella',
              'primary_category',
              'brand',
              'name',
              'package_height',
              'package_length',
              'package_width',
              'package_weight',
              'description',
              'seller_sku',
              'variation',
              'parent_sku',
              'alto',
              'largo',
              'ancho',
              'peso',
              'peso_del_producto',
              'condition_type',
              'color',
              'profundidad',
              'product_id',
              'product_warranty',
              'seller_warranty,',
              'package_content',
              'talla',
              'color_basico',
              'modo_de_fabricacion',
              'nombre_del_fabricante_o_importador',
              'seller_warranty'
            ];
            const attributeNames = data.data.data.map(attr => attr.Name);
            const notFound = fieldsToSkip.filter(field => !attributeNames.includes(field));
            const talla = data.data.data.filter(attr => attr.Name === 'talla');
            console.log("talla", talla);
            
            // Extraer solo los nombres de las opciones de talla
            if (talla.length > 0 && talla[0].Options && talla[0].Options.Option) {
              const tallaOptions = Array.isArray(talla[0].Options.Option) 
                ? talla[0].Options.Option 
                : [talla[0].Options.Option];
              
              const tallaNames = tallaOptions.map(option => option.Name);
              setTalla(tallaNames);
            } else {
              setTalla([]);
            }
            setNotFoundFields(notFound); // Guardar en el estado
            console.log("Campos de fieldsToSkip que NO existen en los atributos de la categoría:", notFound);

            // Reportar al padre los atributos obligatorios de la categoría (para validar antes de avanzar)
            if (setRequiredAttributes) {
              const requiredList = data.data.data
                .filter(attr => attr.isMandatory === "1" && !fieldsToSkip.includes(attr.Name))
                .map(attr => ({ FeedName: attr.FeedName, Label: attr.Label, GroupName: attr.GroupName }));
              setRequiredAttributes(requiredList);
              console.log("Atributos obligatorios de la categoría:", requiredList);
            }
          }
        });
    }
  }, [category, globalContext.currentEnterpriseId]);

  // Función para limpiar descripciones (eliminar texto en inglés)
  const cleanDescription = (description) => {
    if (!description) return '';
    
    // Dividir por "//" y tomar solo la parte en español
    const spanishPart = description.split('//')[0].trim();
    return spanishPart;
  };

  // Función para renderizar campos dinámicos separados por secciones
  const renderDynamicFields = (attributes) => {
    // Campos que se deben omitir
    const fieldsToSkip = [
      'price_falabella',
      'sale_price_falabella', 
      'sale_start_date_falabella',
      'sale_end_date_falabella',
      'TaxClass',
      'quantity_falabella',
      'primary_category',
      'brand',
      'name',
      'package_height',
      'package_length',
      'package_width',
      'package_weight',
      'description',
      'seller_sku',
      'variation',
      'parent_sku',
      'alto',
      'largo',
      'ancho',
      'peso',
      'peso_del_producto',
      'condition_type',
      'color',
      'profundidad',
      'product_id',
      'product_warranty',
      'seller_warranty,',
      'package_content',
      'talla',
      'color_basico',
      'modo_de_fabricacion',
      'nombre_del_fabricante_o_importador',
      'seller_warranty'
    ];

     
    // Filtrar los atributos para omitir campos específicos
    const filteredAttributes = attributes.filter(attr => !fieldsToSkip.includes(attr.Name));

    // Separar campos requeridos y opcionales
    const requiredFields = filteredAttributes.filter(attr => attr.isMandatory === "1");
    const optionalFields = filteredAttributes.filter(attr => attr.isMandatory === "0");

    const renderFieldSection = (fieldsList, sectionTitle) => {
      if (fieldsList.length === 0) return null;

      return (
        <>
          <Text size='13pt' fw='600' style={{ margin: '20px 0 10px 0', paddingTop: 20, color: '#333', width: '100%', display: 'block', borderBottom: '1px solid #333' }}>
            {sectionTitle} 
          </Text>
          {fieldsList.map((attr, index) => {
            const isRequired = attr.isMandatory === "1";
            
            // Función para manejar cambios en los campos - CORREGIDA
            const handleFieldChange = (value) => {
              console.log('Guardando campo:', attr.FeedName, 'con valor:', value);
              let copyArray = [...paramsToSend];
              if (!copyArray[currentIndex].categoryAttributes) {
                copyArray[currentIndex].categoryAttributes = { variation: {}, general: {}, notFoundFields: notFoundFields, fieldsToResponse: {} };
              }
              if (!copyArray[currentIndex].categoryAttributes.variation) {
                copyArray[currentIndex].categoryAttributes.variation = {};
              }
              if (!copyArray[currentIndex].categoryAttributes.general) {
                copyArray[currentIndex].categoryAttributes.general = {};
              }
              // Mantener notFoundFields actualizado
              copyArray[currentIndex].categoryAttributes.notFoundFields = notFoundFields;
              // Agrupar por GroupName
              if (attr.GroupName === "Variation") {
                copyArray[currentIndex].categoryAttributes.variation[attr.FeedName] = value;
              } else {
                copyArray[currentIndex].categoryAttributes.general[attr.FeedName] = value;
              }

              // Guardar talla en fieldsToResponse
              copyArray[currentIndex].categoryAttributes.fieldsToResponse.talla = talla;

              setParamsToSend(copyArray);
              console.log('Estado actualizado:', copyArray[currentIndex].categoryAttributes);
              
              // Limpiar errores si hay
              if (validationErrors.length > 0) {
                setValidationErrors([]);
              }
            };

            // Obtener valor actual del campo
            let currentValue = '';
            if (attr.GroupName === "Variation") {
              currentValue = paramsToSend[currentIndex]?.categoryAttributes?.variation?.[attr.FeedName] || '';
            } else {
              currentValue = paramsToSend[currentIndex]?.categoryAttributes?.general?.[attr.FeedName] || '';
            }

            const renderField = () => {
              switch (attr.InputType) {
                case 'textfield':
                  return (
                    <FormProduct.Input
                      type="text"
                      placeholder={cleanDescription(attr.ExampleValue) || `Ingrese ${cleanDescription(attr.Label).toLowerCase()}`}
                      value={currentValue}
                      maxLength={attr.MaxLength || undefined}
                      onChange={(e) => handleFieldChange(e.target.value)}
                    />
                  );

                case 'numberfield':
                  return (
                    <FormProduct.Input
                      type="number"
                      placeholder={cleanDescription(attr.ExampleValue) || `Ingrese ${cleanDescription(attr.Label).toLowerCase()}`}
                      value={currentValue}
                      maxLength={attr.MaxLength || undefined}
                      onChange={(e) => handleFieldChange(e.target.value)}
                    />
                  );

                case 'textarea':
                  return (
                    <FormProduct.TextArea
                      placeholder={cleanDescription(attr.ExampleValue) || `Ingrese ${cleanDescription(attr.Label).toLowerCase()}`}
                      value={currentValue}
                      onChange={(e) => handleFieldChange(e.target.value)}
                      rows={4}
                      style={{ width: '100%' }}
                    />
                  );

                case 'datefield':
                  return (
                    <FormProduct.Input
                      type="date"
                      value={currentValue}
                      onChange={(e) => handleFieldChange(e.target.value)}
                    />
                  );

                case 'dropdown':
                  // Validar si Options tiene contenido válido
                  const hasValidOptions = attr.Options && 
                    attr.Options !== "" && 
                    attr.Options.Option && 
                    (Array.isArray(attr.Options.Option) ? attr.Options.Option.length > 0 : true);

                  // Si no hay opciones válidas, renderizar como input
                  if (!hasValidOptions) {
                    return (
                      <FormProduct.Input
                        type="text"
                        placeholder={cleanDescription(attr.ExampleValue) || `Ingrese ${cleanDescription(attr.Label).toLowerCase()}`}
                        value={currentValue}
                        maxLength={attr.MaxLength || undefined}
                        onChange={(e) => handleFieldChange(e.target.value)}
                      />
                    );
                  }

                  // Manejar opciones que pueden venir como objeto o array
                  let options = [];
                  if (Array.isArray(attr.Options.Option)) {
                    options = attr.Options.Option;
                  } else {
                    options = [attr.Options.Option];
                  }

                  const selectOptions = options.map(option => ({
                    value: option.Name,
                    label: cleanDescription(option.Name)
                  }));

                  return (
                    <Select styles={{
                      control: (base) => ({
                        ...base,
                        width: '100%'
                      }),
                      container: (base) => ({
                        ...base,
                        width: '100%'
                      })
                    }}
                      value={currentValue ? { value: currentValue, label: cleanDescription(currentValue) } : null}
                      onChange={(selected) => handleFieldChange(selected ? selected.value : '')}
                      options={selectOptions}
                      placeholder={`Seleccionar ${cleanDescription(attr.Label).toLowerCase()}`}
                      isClearable={false}
                    />
                  );

                default:
                  return (
                    <FormProduct.Input
                      type="text"
                      placeholder={cleanDescription(attr.ExampleValue) || `Ingrese ${cleanDescription(attr.Label).toLowerCase()}`}
                      value={currentValue}
                      onChange={(e) => handleFieldChange(e.target.value)}
                    />
                  );
              }
            };

            return (
              <FormProduct.ContInputAndLabel 
                key={`${sectionTitle}-${index}`}
                w={attr.InputType === 'textarea' ? '700px' : '340px'} 
                mr='5px'
              >
                <Text size='12pt' fw='500'>
                  {cleanDescription(attr.Label)}
                  {isRequired && <sup style={{ color: 'red' }}>*</sup>}
                </Text>
                {renderField()}
                {attr.Description && (
                  <Text size='10pt' cl='#666' style={{ marginTop: '4px', fontStyle: 'italic' }}>
                    {cleanDescription(attr.Description)}
                  </Text>
                )}
              </FormProduct.ContInputAndLabel>
            );
          })}
        </>
      );
    };

    return (
      <>
          <Text size='16pt' fw='600' style={{ margin: '20px 0 10px 0', paddingTop: 30, color: '#333', width: '100%', display: 'block', textAlign: 'center'}}>
            Caracteristicas generales para todos los productos
          </Text>
        {renderFieldSection(requiredFields, "Campos Requeridos")}
        {renderFieldSection(optionalFields, "Campos Opcionales")}
      </>
    );
  };

  // Función para convertir centímetros a metros
  const convertCmToMeters = (cm) => {
    if (!cm || isNaN(cm)) return 0;
    return Number(cm) / 100;
  };

  // Cargar automáticamente campos como medidas y descripción
  useEffect(() => {
    if (paramsToSend.length > 0 && paramsToSend[currentIndex]) {
      let copyArray = [...paramsToSend];
      const currentProduct = copyArray[currentIndex];
      console.log('*************************************************')
      console.log(currentProduct, 'currentProduct')
      console.log('*************************************************')
      // Establecer medidas por defecto si no existen
      if (!currentProduct.PackagedHeight) {
        currentProduct.PackagedHeight = currentProduct.height || "0"; // Valor por defecto o desde el producto original
      }
      if (!currentProduct.PackagedLength) {
        currentProduct.PackagedLength = currentProduct.length || "0"; // Valor por defecto o desde el producto original
      }
      if (!currentProduct.PackagedWidth) {
        currentProduct.PackagedWidth = currentProduct.width || "0"; // Valor por defecto o desde el producto original
      }
      if (!currentProduct.PackagedWeightKg) {
        currentProduct.PackagedWeightKg = currentProduct.weight || "0"; // Valor por defecto o desde el producto original
      }
      
      // Establecer descripción por defecto si no existe
      if (!currentProduct.Description) {
        currentProduct.Description = currentProduct.description || "Descripción del producto";
      }
      
      // Establecer marca por defecto si no existe
      if (!currentProduct.BrandName) {
        currentProduct.BrandName = currentProduct.brand || "";
      }
      
      // Establecer SKU por defecto si no existe
      if (!currentProduct.sku) {
        currentProduct.sku = currentProduct.sku || "";
      }
      
      // Asegurarse de que categoryAttributes existe
      if (!currentProduct.categoryAttributes) {
        currentProduct.categoryAttributes = { variation: {}, general: {}, notFoundFields: [], fieldsToResponse: {} };
      }

      // Actualizar notFoundFields en categoryAttributes
      currentProduct.categoryAttributes.notFoundFields = notFoundFields;
      setParamsToSend(copyArray);
    }
  }, [currentIndex, paramsToSend.length, notFoundFields]);

  const publishGroupedV = (v) => {
    // Actualizar el estado global
    if (setPublishGroup) {
      setPublishGroup(v);
    }
  };

  const groupedOptions = [
    {
      value: "true",
      description: "Agrupadas",
    },
    {
      value: "false",
      description: "Separadas",
    },
  ];

  return (
    <div style={{ width: "100%", height: "auto" }}>
      <ListOfProductsToSetParams sendToFormData={sendToFormData} paramsToSend={paramsToSend} setParamsToSend={setParamsToSend}  />
      {paramsToSend.length > 0 && (
        <FormProduct.ContForms>
          <FormProduct.Contform>
            <FormProduct.HeaderContForm>
              <Text size='13pt' fw='500' cl='#FFFFFF'>
                Parametros Generales
              </Text>
            </FormProduct.HeaderContForm>
            <FormProduct.BodyContForm>
              <FormProduct.ContInputAndLabel w='340px'>
                <Text size='12pt' fw='500'>
                  Publicar variantes como
                  <sup>*</sup>
                </Text>
                <FormProduct.Select
                  value={publishGroup}
                  onChange={(e) => {
                    publishGroupedV(e.target.value);
                  }}
                >
                  <option disabled>Seleccionar</option>
                  {groupedOptions.map((val, i) => (
                    <option
                      key={i}
                      value={val.value}
                      selected={val.value === publishGroup}
                    >
                      {val.description}
                    </option>
                  ))}
                </FormProduct.Select>
              </FormProduct.ContInputAndLabel>
            </FormProduct.BodyContForm>
          </FormProduct.Contform>

          <FormProduct.Contform>
            <FormProduct.HeaderContForm>
              <Text size='13pt' fw='500' cl='#FFFFFF'>
                Llene los parametros para el producto a publicar
              </Text>
            </FormProduct.HeaderContForm>
            <FormProduct.BodyContForm>
              <FormProduct.ContInputAndLabel mr='5px'>
                <Text size='12pt' fw='500'>
                  Titulo de la Publicacion
                  <sup>*</sup>
                </Text>
                <Text size='10pt' fw='400' cl='#666'>
                  Ingresa el nombre real del producto, que debe incluir el nombre, marca, color, edición o modelo y capacidad, etc.
                </Text>
                <FormProduct.Input
                  placeholder='Titulo de la Publicacion'
                  value={paramsToSend[currentIndex]?.Title || ""}
                  onChange={(e) => titleFunc(e.target.value)}
                  maxLength={60}
                />
              </FormProduct.ContInputAndLabel>

              <FormProduct.ContInputAndLabel w='340px'>
                <Text size='12pt' fw='500'>
                  Precio
                  <sup>*</sup>
                </Text>
                <FormProduct.Input
                  disabled={true}
                  placeholder='Precio para la publicacion'
                  value={paramsToSend[currentIndex]?.Price || ""}
                />
              </FormProduct.ContInputAndLabel>

              <FormProduct.ContInputAndLabel w='340px'>
                <Text size='12pt' fw='500'>
                  Marca de Producto
                  <sup>*</sup>
                </Text>
                {loadingBrands ? (
                  <Text size='10pt' fw='400' cl='#666'>Cargando marcas...</Text>
                ) : (
                      <Select styles={{
                        control: (base) => ({
                          ...base,
                          width: '100%'
                        }),
                        container: (base) => ({
                          ...base,
                          width: '100%'
                        })
                      }}
                      value={paramsToSend[currentIndex]?.Brand ? {
                        value: `${paramsToSend[currentIndex].Brand.brandId}|${paramsToSend[currentIndex].Brand.name}`,
                        label: paramsToSend[currentIndex].Brand.name
                      } : null}
                      onChange={(selected) => brandFunc(selected.value)}
                      options={brands.map(brand => ({
                        value: `${brand.brandId}|${brand.name}`,
                        label: brand.name
                      }))}
                      placeholder="Seleccionar marca"
                      isClearable={false}
                    />
                )}
                {brands.length === 0 && !loadingBrands && (
                  <Text size='10pt' fw='400' cl='#666' style={{marginTop: '5px'}}>
                    No se encontraron marcas disponibles
                  </Text>
                )}
              </FormProduct.ContInputAndLabel>

              <FormProduct.ContInputAndLabel w='340px'>
                <Text size='12pt' fw='500'>
                  Categoria seleccionada
                  <sup>*</sup>
                </Text>
                <FormProduct.Input
                  disabled={true}
                  value={category.name}
                />
              </FormProduct.ContInputAndLabel>

              {/* Campos de medidas y peso */}
              <FormProduct.ContInputAndLabel w='340px' mr='5px'>
                <Text size='12pt' fw='500'>
                    Alto del producto empacado (cm)
                  <sup>*</sup>
                </Text>
                <FormProduct.Input
                  type="number"
                  placeholder='Altura en centímetros'
                  value={paramsToSend[currentIndex]?.PackagedHeight || ""}
                  onChange={(e) => packagedHeight(e.target.value)}
                />
              </FormProduct.ContInputAndLabel>

              <FormProduct.ContInputAndLabel w='340px' mr='5px'>
                <Text size='12pt' fw='500'>
                  Largo del producto empacado (cm)
                  <sup>*</sup>
                </Text>
                <FormProduct.Input
                  type="number"
                  placeholder='Longitud en centímetros'
                  value={paramsToSend[currentIndex]?.PackagedLength || ""}
                  onChange={(e) => packagedLength(e.target.value)}
                />
              </FormProduct.ContInputAndLabel>

              <FormProduct.ContInputAndLabel w='340px' mr='5px'>
                <Text size='12pt' fw='500'>
                    Ancho del producto empacado (cm)
                  <sup>*</sup>
                </Text>
                <FormProduct.Input
                  type="number"
                  placeholder='Ancho en centímetros'
                  value={paramsToSend[currentIndex]?.PackagedWidth || ""}
                  onChange={(e) => packagedWidth(e.target.value)}
                />
              </FormProduct.ContInputAndLabel>

              <FormProduct.ContInputAndLabel w='340px' mr='5px'>
                <Text size='12pt' fw='500'>
                    Peso del producto empacado (kg)
                  <sup>*</sup>
                </Text>
                <FormProduct.Input
                  type="number"
                  step="0.1"
                  placeholder='Peso en kilogramos'
                  value={paramsToSend[currentIndex]?.PackagedWeightKg || ""}
                  onChange={(e) => packagedWeightKg(e.target.value)}
                />
              </FormProduct.ContInputAndLabel>

              {/* Campo de descripción */}
              <FormProduct.ContInputAndLabel w='700px' mr='5px'>
                <Text size='12pt' fw='500'>
                  Descripción del Producto
                  <sup>*</sup>
                </Text>
                <FormProduct.TextArea
                  placeholder='Descripción detallada del producto'
                  value={paramsToSend[currentIndex]?.Description || ""}
                  onChange={(e) => bodyFunc(e.target.value)}
                  rows={6}
                  style={{ width: '100%' }}
                />
              </FormProduct.ContInputAndLabel>

              {/* Campos dinámicos de categoría */}
              {categoryAttributes && categoryAttributes.length > 0 && (
                <>
                  {renderDynamicFields(categoryAttributes)}
                </>
              )}
            </FormProduct.BodyContForm>
          </FormProduct.Contform>
        </FormProduct.ContForms>
      )}
    </div>
  );
}
